import propTypes from 'prop-types';
import React from 'react';
import Translation from '../../i18n/Translation';
import HistoryItem from './HistoryItem';

export const History = ({ history }) => (
  <div className="withdrawal-history">
    <h1 className="withdrawal-history__header">
      <Translation section="withdraw" label="historyHeader" />
    </h1>
    {history.map(item => (
      <HistoryItem
        key={item.id}
        amount={item.amount}
        datetime={item.datetime}
        status={item.status}
      />
    ))}
    <p className="withdrawal-history__footer">
      <Translation section="withdraw" label="historyFooter" />{' '}
      <a
        className="withdrawal-history__footer-link"
        target="_blank"
        href="https://sports.williamhill.com/betting/"
        rel="noopener noreferrer"
      >
        <Translation section="common" label="williamhillcom" />
      </a>
    </p>
  </div>
);

History.propTypes = {
  history: propTypes.object.isRequired
};

export default History;
